module.exports = __webpack_public_path__ + "e50580171ea0388cb342c5c1c87c8ec8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/reading-off.png
// module id = 1671
// module chunks = 0